import { createRouter, createWebHistory } from "vue-router";
import { isAuthenticated, refreshSession } from "../services/auth";
import LoginView from "../views/LoginView.vue";
import OverviewView from "../views/OverviewView.vue";
import AssetDetailView from "../views/AssetDetailView.vue";
import TasksBoardView from "../views/TasksBoardView.vue";
import ExternalAssetsView from "../views/ExternalAssetsView.vue";
import MaintenanceView from "../views/MaintenanceView.vue";
import VehiclesView from "../views/VehiclesView.vue";
import ExpensesView from "../views/ExpensesView.vue";
import ProfileView from "../views/ProfileView.vue";
import AppShell from "../components/layout/AppShell.vue";
import HealthView from "../views/HealthView.vue";
import InsuranceView from "../views/InsuranceView.vue";
import InsuranceDetailView from "../views/InsuranceDetailView.vue";
import FileExplorerView from "../views/FileExplorerView.vue";

const routes = [
  { path: "/", redirect: "/dashboard/overview" },
  { path: "/login", name: "login", component: LoginView, meta: { public: true } },
  {
    path: "/dashboard",
    component: AppShell,
    meta: { requiresAuth: true },
    children: [
      { path: "overview", name: "overview", component: OverviewView },
      { path: "assets/:symbol", name: "asset-detail", component: AssetDetailView, props: true },
      { path: "external-assets", name: "external-assets", component: ExternalAssetsView },
      { path: "expenses", name: "expenses", component: ExpensesView },
      { path: "insurances", name: "insurances", component: InsuranceView },
      { path: "insurances/:id", name: "insurance-detail", component: InsuranceDetailView },
      { path: "profile", name: "profile", component: ProfileView },
      {
        path: "documents",
        name: "documents",
        component: MaintenanceView,
        props: { category: "PERSONAL", title: "Documentos" },
      },
      { path: "health", name: "health", component: HealthView },
      { path: "tasks", name: "tasks-board", component: TasksBoardView },
      {
        path: "maintenance/vehicles",
        name: "maintenance-vehicles",
        component: VehiclesView,
      },
      {
        path: "maintenance/vehicles/:id",
        name: "vehicle-detail",
        component: MaintenanceView,
        props: (route) => ({
          category: "VEHICLE",
          title: "Vehículo",
          vehicleId: route.params.id,
        }),
      },
      {
        path: "maintenance/home",
        name: "maintenance-home",
        component: MaintenanceView,
        props: { category: "HOME", title: "Mantenimientos casa" },
      },
      {
        path: "maintenance/taxes",
        name: "maintenance-taxes",
        component: MaintenanceView,
        props: { category: "TAX", title: "Impuestos" },
      },
      {
        path: "admin/files",
        name: "admin-files",
        component: FileExplorerView,
      },
    ],
  },
  { path: "/:pathMatch(.*)*", redirect: "/dashboard/overview" },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to) => {
  if (to.meta.public) {
    if (to.path === "/login" && isAuthenticated()) {
      return "/dashboard/overview";
    }
    return true;
  }

  if (to.meta.requiresAuth && !isAuthenticated()) {
    const refreshed = await refreshSession();
    if (refreshed) {
      return true;
    }
    return "/login";
  }
  return true;
});

export default router;
